import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getRouteMutationKey } from '.';
import { reportService } from '../../../../application/ReportService';
import { StopReport } from '../../../../domain/report/StopReport';
import { Route } from '../../../../domain/route/Route';

interface UseDeleteStopReportDataProps {
  stopReport: StopReport;
}

type UseDeleteStopReportResponseProps = ServiceResponse<
  ({ stopReport }: UseDeleteStopReportDataProps) => void,
  void
> & {
  reset: () => void;
};

interface UseDeleteStopReportProps {
  driverRoute: Route;
}

// Hooks act as 'Adapter' layer.
export const useDiscardReport = ({ driverRoute }: UseDeleteStopReportProps): UseDeleteStopReportResponseProps => {
  const queryClient = useQueryClient();

  const { isLoading, isSuccess, isError, mutate, reset } = useMutation<void, unknown, { stopReport: StopReport }>(
    async ({ stopReport }: { stopReport: StopReport }): Promise<void> => {
      await reportService.discardReport({ stopReport });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getRouteMutationKey({ routeId: driverRoute.id }));
      },
    }
  );

  const discardReport = ({ stopReport }: UseDeleteStopReportDataProps) => {
    mutate({ stopReport });
  };

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    run: discardReport,
    reset,
  };
};
